// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__na69P","colMin":"styles_colMin__1bqH4","colCheckbox":"styles_colCheckbox__3Wggc"};